<template>
	<div>
		<a-page-header style="background: #fff;" title="充值记录" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'充值记录'}]}}">
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input-group compact>
						<a-select style="width: 120px" v-model="searchForm.type">
							<a-select-option :value="1">姓名</a-select-option>
							<a-select-option :value="2">昵称</a-select-option>
							<a-select-option :value="3">电话</a-select-option>
							<a-select-option :value="4">支付单号</a-select-option>
						</a-select>
						<a-input style="width: 300px" placeholder="请输入内容" v-model="searchForm.word" />
					</a-input-group>
				</a-form-model-item>
				<a-form-model-item>
					<a-range-picker :locale="locale" format="YYYY-MM-DD" @change="dateChange" />
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="rechargeWx" slot-scope="text,rechargeWx">
						<a-avatar :src="rechargeWx.wxInfo.headpic" />
						{{rechargeWx.wxInfo.nickname}}
						<a-icon type="man" style="color:#597ef7 ;" v-if="rechargeWx.wxInfo.sex == 1" />
						<a-icon style="color:#f759ab ;" type="woman" v-if="rechargeWx.wxInfo.sex == 2" />
					</span>
					<span slot="rechargeMember" slot-scope="text,rechargeMember">
						<div>姓名 {{rechargeMember.rechargeUser.memberName}}</div>
						<div>电话 {{rechargeMember.rechargeUser.memberPhone}}</div>
						<div>等级 <a-tag color="orange">{{rechargeMember.rechargeUser.levelName}}</a-tag></div>
					</span>	
					<span slot="rechargeMoney" slot-scope="text,rechargeMoney">
						<div>
							支付 <span>{{rechargeMoney.rechargeMoney}} 元</span>
						</div>
						<div>
							赠送 <span>{{rechargeMoney.rechargeSend}} 元</span>
						</div>
						<div>
							实到 <span>{{rechargeMoney.rechargeMoneyAll}} 元</span>
						</div>
					</span>
					<span slot="housetypeHouse" slot-scope="text,housetypeHouse">
						<a @click="toHouseDetail(housetypeHouse.housetypeHouse)">{{housetypeHouse.housetypeHouseName}}</a>
					</span>
					<span slot="housetypeBuildArea" slot-scope="housetypeBuildArea">
						{{housetypeBuildArea}} 平方米
					</span>
					<span slot="housetypeInArea" slot-scope="housetypeInArea">
						{{housetypeInArea}} 平方米
					</span>
				</a-table>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from "moment"
	import 'moment/locale/zh-cn'
	import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '微信信息',
			dataIndex: 'rechargeWx',
			scopedSlots: {
				customRender: 'rechargeWx'
			},
		},
		{
			title: '会员信息',
			dataIndex: 'rechargeMember',
			scopedSlots: {
				customRender: 'rechargeMember'
			},
		},
		{
			title: '充值金额',
			dataIndex: 'rechargeMoney',
			scopedSlots: {
				customRender: 'rechargeMoney'
			},
		},
		{
			title: '微信支付单号',
			dataIndex: 'rechargeWxOrderNum',
			scopedSlots: {
				customRender: 'rechargeWxOrderNum'
			},
		},
		{
			title: '充值时间',
			dataIndex: 'addTime',
			scopedSlots: {
				customRender: 'addTime'
			},
		}
	];

	export default {
		data() {
			return {
				moment,
				locale,
				columns,
				list: [],
				searchForm: {
					type:1
				},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				loading: false,
				uid:''
			};
		},

		mounted() {
			this.uid = this.$route.query.wx
			this.getList()
		},

		methods: {
			dateChange(value, dateString){
				console.log(value, dateString)
				this.searchForm.dateBegin = dateString[0]
				this.searchForm.dateEnd = dateString[1]
			},
			
			toDetail(id) {
				this.$router.push('/housetypeDetail?id=' + id)
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.pagination.field = sorter.field
				this.pagination.order = sorter.order
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					uid:this.uid ? this.uid:'',
					page: this.pagination.current,
					num: this.pagination.pageSize,
					field: this.pagination.field,
					order: this.pagination.order,
					type: this.searchForm.type,
					word: this.searchForm.word,
					startTime: this.searchForm.dateBegin,
					endTime: this.searchForm.dateEnd,
				}
				this.$http.post('/admin/index.php/admin/Shop/rechargeList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
		}
	}
</script>

<style scoped="">
	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}
</style>
